// client/src/components/SubdomainForm.jsx
import React from "react";

/**
 * Dumb component: вся логіка (validate/fetch/state) живе в батьківському компоненті.
 * Тут 1:1 твоя форма з LandingPage, щоб не втратити стилі/класи.
 */
export default function SubdomainForm({
  panelTitle,
  plan, // "basic" | "pro"
  ta,

  firstRef,

  subdomain,
  setSubdomain,

  subError,

  notice,
  clearNotice,

  onBack,   // кнопка назад
  onSubmit, // form submit handler
}) {
  return (
    <form className="services__form services__form--another" onSubmit={onSubmit}>
      <div className="services__title services__title--walen">{panelTitle}</div>

      <div className="services__your-tarif-section">
        <p className="services__your-tarif">{ta?.("landing.your.tariff")}: </p>
        <p className="services__your-tarif services__your-tarif--color">
          {plan === "pro" ? "Pro" : "Basic"}
        </p>
      </div>

      <div className="form-input-fields-block">
        <p className="services__your-domain">
          {ta?.("landing.your.example")}: <strong>example</strong> →{" "}
          <strong>example.best-place.club</strong>
        </p>

        <div className="form-input-fields">
          <input
            ref={firstRef}
            id="subdomain"
            placeholder=" "
            type="text"
            name="subdomain"
            className={`input input--your-name ${subError ? "input--error" : ""}`}
            autoComplete="off"
            value={subdomain}
            onChange={(e) => {
              setSubdomain(e.target.value);
              if (notice?.kind === "error") clearNotice?.();
            }}
            required
          />
          <label htmlFor="subdomain">Subdomain</label>

          {subError && (
            <div className="error-block error-block--visible">
              <span className="input-content-error">{subError}</span>
            </div>
          )}
        </div>
      </div>

      <div className="landing-panel__message-wrapper">
        {notice?.text && (
          <p className={`landing-panel__message landing-panel__message--${notice.kind || "info"}`}>
            {notice.text}
          </p>
        )}
      </div>

      <div className="button__block">
        <button className="services__button-prev" type="button" onClick={onBack}>
          {ta?.("admin.nav.back")}
        </button>

        <button className="services__button-mix" type="submit">
          {ta?.("admin.nav.confirm")}
        </button>
      </div>
    </form>
  );
}
